module.exports = __webpack_public_path__ + "static/img/recommend-list-12.c231a33.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-12.png
// module id = tBIc
// module chunks = 1